/**
 * Fetches chat history from Acordos e Contratos API and parses it to the application's format
 * @param {string} userEmail - The email of the current user
 * @returns {Promise<Array>} Array of chat objects in the application format
 */
async function getAcordosHistory(userEmail) {
  try {
    const ACORDOS_HISTORY_API = process.env.REACT_APP_ACORDOS_HISTORY_API_URL;
    const API_KEY = process.env.REACT_APP_ACORDOS_HISTORY_API_KEY;


    if (!ACORDOS_HISTORY_API || !API_KEY) {
      return [];
    }

    const url = new URL(ACORDOS_HISTORY_API);
    url.searchParams.append("email", userEmail);


    const response = await fetch(url, {
      method: "GET",
      headers: {
        "x-api-key": API_KEY,
        "Accept": "application/json",
      },
    });


    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Acordos History API error: ${response.status}`);
    }

    const data = await response.json();

    // Transform the data to match the expected format
    const chats = [];

    // Process each chat group in the response
    Object.entries(data).forEach(([sessionId, messages]) => {
      // Skip empty conversations or unknown sessions
      if (!messages || messages.length === 0 || sessionId === "unknown-session") {
        return;
      }


      // Sort messages by timestamp to ensure chronological order
      const sortedMessages = [...messages].sort(
        (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
      );

      // Format messages for our application
      const formattedMessages = sortedMessages.map((msg, index) => {
        // Convert timestamp to our date format
        const date = new Date(msg.timestamp);
        const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;

        return {
          id: `${sessionId}${String(index).padStart(5, "0")}`,
          date: formattedDate,
          role: msg.type === "human" ? "user" : "assistant",
          content: msg.text,
          feedback: -1,
        };
      });

      // Create the historic text
      const historic = formattedMessages
        .map((msg) => `${msg.role}:${msg.content}`)
        .join("\n");

      // Create summary from first user message (truncated if needed)
      const firstUserMsg = formattedMessages.find((msg) => msg.role === "user");
      const summary = firstUserMsg
        ? firstUserMsg.content.length > 15
          ? firstUserMsg.content.substring(0, 12) + "..."
          : firstUserMsg.content
        : "Conversa com Engenharia";

      // Add the chat to our array
      chats.push({
        protocol: sessionId,
        summary,
        pinned: false,
        historic,
        knowledge: "",
        type: "acordos",
        messages: formattedMessages,
      });
    });

    return chats;
  } catch (error) {
    return [];
  }
}

export default getAcordosHistory;
